import { createRef } from "react";
import { NavigationContainerRef } from "@react-navigation/native";
import { RootStackParamList } from "src/navigation/types";

export const navigationRef =
  createRef<NavigationContainerRef<RootStackParamList>>();
